/**
 *
 * @param {string} string  - string to be converted into initials
 * @param {string} letterCase - convert the letter case of the initials,
 *  value can be 'uppercase' or 'lowercase'
 *
 * @returns string
 */
const getInitials = (string, letterCase) => {
  if (string) {
    const initials = string
      .split(' ')
      .map(i => i.charAt(0))
      .join('');

    return letterCase === 'uppercase'
      ? initials.toUpperCase()
      : letterCase === 'lowercase'
      ? initials.toLowerCase()
      : initials;
  }

  return null;
};

export default getInitials;
